module.exports = __webpack_public_path__ + "media/images/emblems/Ruswil_LU-efbd12a800afe1ff836f2415a117b9bf.png";